var _ = require('lodash');
var rxSwitchboard = require('ub/control/rx-switchboard');

var NewFeatureTour = require('ub_legacy/lp/new-feature-tour.js');
var MobileTourTemplateBuilder =
  require('ub_legacy/lp/new-feature-tour/mobile-tour-template-builder');

;(function() {
  var config = [{
    name: 'lp-mobile-tour',
    enabled: true,
    options: {
      openSelectorRole: 'mobile-breakpoint-button',
      inputSelectorRole: 'seen-mobile-tour-checkbox',
      templateBuilderConstructor: MobileTourTemplateBuilder
    }
  }];

  var initiateTours = function() {
    _.each(config, function(tour) {
      if (tour.enabled) {
        new NewFeatureTour(tour.name, tour.options).init();
      }
    });
  };

  rxSwitchboard.subjects
    .first_page_load
    .subscribe(initiateTours);
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/new-feature-tour-config.js
// module id = 1051
// module chunks = 0